<template>
  <div class="user-container">
    <div class="table-field">
      <el-row>
        <label style="margin-right: 30px;">开始日期:</label>
        <el-date-picker
          v-model="params.beginTime"
          align="right"
          type="date"
          placeholder="选择开始日期"
          style="width:150px;"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <label style="margin:0 30px;">结束日期:</label>
        <el-date-picker
          v-model="params.endTime"
          align="right"
          type="date"
          placeholder="选择结束日期"
          style="width:150px;"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-button style="margin:0 30px;" type="primary" @click="handleSearch">查询</el-button>
        <el-button type="info" @click="handleExportOrderDetailExecl">导出</el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
      show-summary
      :summary-method="handleTotal"
    >
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="body" label="收费类目" width="280"></el-table-column>
      <el-table-column prop="totalFee" label="总金额（元）"></el-table-column>
      <el-table-column prop="total" label="总比数"></el-table-column>
      <el-table-column prop="avgAmount" label="人平均金额" width="180"></el-table-column>
      <el-table-column prop="feeTotal" label="手续费"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { orderTotal } from "@/axios/api";
import { exportOrderTotal } from "@/axios/excel-api";
export default {
  data() {
    return {
      tableData: [{}],
      params: {
        beginTime: new Date(),
        endTime: new Date(),
      },
      total: 0,
      totalize: {}
    };
  },
  methods: {
    handleExportOrderDetailExecl() {
      exportOrderTotal(this.params).then(res => {
        var blob = new Blob([res], {
          type: "application/octet-stream;charset=utf-8"
        });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "ALL_" + this.params.beginTime + "_" + this.params.endTime + ".xls"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href);
      });
    },
    handleSearch() {
      this.handleOrderList();
    },
    handleOrderList() {
      orderTotal(this.params).then(res => {
        this.tableData = res.data.totalOrder;
        this.totalize = res.data.totalParams;
      });
    },
    handleClickPage(event) {
      this.params.page = event;
      this.handleOrderList();
    },
    handleTotal($event) {
      const { columns, data } = $event;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计:";
          return;
        }
        switch (column.property) {
          case "totalFee":
            sums[index] = this.totalize.totalFee;
            break;
          case "total":
            sums[index] = this.totalize.total;
            break;
          case "feeTotal":
            sums[index] = this.totalize.feeTotal;
            break;
          default:
            break;
        }
      });
      return sums;
    }
  },
  mounted() {
    this.handleOrderList();
  }
};
</script>

<style>
.table-field .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-field {
  width: auto;
  height: 100px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: row;
  padding: 0 50px;
  box-sizing: border-box;
  padding: 30px;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/order/OrderTotalList.vue